import { Component } from '@angular/core';

@Component({
  selector: 'app-counselling-links',
  templateUrl: './counselling-links.component.html',
  styleUrls: ['./counselling-links.component.scss']
})
export class CounsellingLinksComponent {

}
